// /crm/hooks/useCRMFilters.js
import { useState, useRef } from "react";
import { format, subDays } from "date-fns";

export function useCRMFilters() {
  const [dateFilters, setDateFilters] = useState({ value: "all", slider: false });
  const [customRange, setCustomRange] = useState({ start: null, end: null });
  const [callFilters, setCallFilters] = useState({ timing: [], assignee: [], outcome: [] });
  const [sourceFilter, setSourceFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState("");
  const searchTimer = useRef(null);

  const getBackendDates = () => {
    if (dateFilters.value === "last30") {
      const end = new Date();
      const start = subDays(end, 30);
      return {
        startDate: format(start, "yyyy-MM-dd"),
        endDate: format(end, "yyyy-MM-dd"),
      };
    }

    if (dateFilters.value === "custom" && customRange.start && customRange.end) {
      return {
        startDate: format(new Date(customRange.start), "yyyy-MM-dd"),
        endDate: format(new Date(customRange.end), "yyyy-MM-dd"),
      };
    }

    return {};
  };

  return {
    dateFilters,
    setDateFilters,
    customRange,
    setCustomRange,
    callFilters,
    setCallFilters,
    sourceFilter,
    setSourceFilter,
    searchQuery,
    setSearchQuery,
    getBackendDates,
    searchTimer
  };
}
